import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import { icon } from './ui';
export default class ServerStatus extends Component {
  loading = false;
  loaded = false;
  copied = false;
  online = false;
  players = 0;
  maxPlayers = (() => Number(app.forum.attribute('novatruckServerMaxPlayers') || 500))();
  serverName = 'NovaTruck & RP';
  gameVersion = '';
  refreshTimer = null;
  oninit(vnode) {
    super.oninit(vnode);
    this.refresh();
    this.refreshTimer = window.setInterval(() => this.refresh(), 30000);
  }
  onremove() {
    if (this.refreshTimer) window.clearInterval(this.refreshTimer);
  }
  async refresh() {
    const endpoint = String(app.forum.attribute('novatruckServerStatusUrl') || 'https://api.novatruck-rp.pl/v1/server/status').trim();
    if (this.loading) return;
    this.loading = true;
    try {
      const response = await fetch(endpoint, {
        credentials: 'omit',
        headers: {
          Accept: 'application/json'
        }
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data = await response.json();
      this.online = data.online !== false;
      const players = data.online_players ?? data.players;
      const maxPlayers = data.max_players ?? data.maxPlayers;
      this.players = Number.isFinite(Number(players)) ? Number(players) : 0;
      this.maxPlayers = Number.isFinite(Number(maxPlayers)) ? Number(maxPlayers) : this.maxPlayers;
      this.serverName = data.server_name || data.name || this.serverName;
      this.gameVersion = data.game_version || '';
      this.loaded = true;
    } catch {
      this.online = false;
      this.loaded = true;
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  view() {
    const address = app.forum.attribute('novatruckServerAddress') || '51.83.182.99:20236';
    const stateLabel = !this.loaded ? 'SPRAWDZANIE…' : this.online ? 'SERWER ONLINE' : 'SERWER OFFLINE';
    return m("div", {
      className: "container NtStatusWrap"
    }, m("section", {
      className: `NtStatus ${this.online ? 'is-online' : 'is-offline'} ${this.loading ? 'is-loading' : ''}`,
      "aria-label": "Status serwera"
    }, m("div", {
      className: "NtStatus-item NtStatus-state"
    }, m("span", {
      className: "NtStatus-dot"
    }), m("span", {
      className: "NtStatus-text"
    }, m("small", null, "Status live"), m("strong", null, stateLabel))), m("div", {
      className: "NtStatus-item NtStatus-players"
    }, m("span", {
      className: "NtStatus-icon"
    }, icon('fas fa-users')), m("span", {
      className: "NtStatus-text"
    }, m("small", null, "Gracze online"), m("strong", null, this.loaded ? `${this.players} / ${this.maxPlayers}` : '— / —'))), m("button", {
      className: "NtStatus-item NtStatus-address",
      type: "button",
      onclick: () => this.copyAddress(String(address))
    }, m("span", {
      className: "NtStatus-icon"
    }, icon('fas fa-server')), m("span", {
      className: "NtStatus-text"
    }, m("small", null, "Adres serwera"), m("strong", null, address)), m("span", {
      className: "NtStatus-copy"
    }, this.copied ? 'Skopiowano!' : 'Kopiuj')), m("button", {
      className: "NtStatus-refresh",
      type: "button",
      "aria-label": "Od\u015Bwie\u017C status",
      disabled: this.loading,
      onclick: () => this.refresh()
    }, icon('fas fa-sync-alt'))));
  }
  async copyAddress(address) {
    try {
      await navigator.clipboard.writeText(address);
      this.copied = true;
      m.redraw();
      window.setTimeout(() => {
        this.copied = false;
        m.redraw();
      }, 1800);
    } catch {
      this.copied = false;
    }
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/ServerStatus', ServerStatus);